<template>
  <ubi-page-container>
    <el-dialog
        center
        :visible.sync="productActivated"
        :close-on-click-modal="false"
        :show-close="true"
        :close-on-press-escape="true"
        width="40%">
      <div v-html="$t('activateProduct.productActivateResponse')" style="text-align: center;"></div>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>

    <div v-if="sitimmoUser.univers == 'IMMO'">
      <ProduitQualiformaImmo />
    </div>
    <div v-else>
      <ProduitQualiformaVo />
    </div>

    <el-container>
      <el-main style="text-align: center;">
        <el-form
          ref="activationProductForm"
          label-position="top"
          @submit-valid="tryActivate"
          @submit-error="onError"
        >
          <el-button class="el-button inline el-button--danger" native-type="submit" type="danger" style="width: 250px;">{{ $t("activateProduct.labelButton") }}</el-button>
        </el-form>
        <br /><br />
      </el-main>
    </el-container>

  </ubi-page-container>
</template>

<script>

import { updateAnnonceurMailtracking } from '@/services/annonceur'
import ProduitQualiformaImmo from '@/pages/produits/ProduitQualiformaImmo'
import ProduitQualiformaVo from '@/pages/produits/ProduitQualiformaVo'

export default {
  name: 'ProduitQualiforma',
  components: { ProduitQualiformaVo, ProduitQualiformaImmo },
  data () {
    return {
      productActivated: false,
      error: null
    }
  },
  computed: {
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  },
  methods: {
    onError (error) {
      this.error = error
      this.$message({ message: this.$t('error.found'), type: 'error' })
    },
    async tryActivate () {
      this.error = null
      const params = { idAnnonceur: this.sitimmoUser.id, hasScoring: true }
      const response = await updateAnnonceurMailtracking(this.sitimmoUser.id, params)
      if (response.error) {
        this.onError(response.error)
      } else {
        this.productActivated = true
      }
    }
  }
}
</script>

<style>
</style>
